import { IDichVuHoSo } from "../../model/respone/dich-vu/IDichVuHoSo";
import { apiClient } from "../apiClient";

export const DICH_VU_HO_SO_ENDPOINT = "dich-vu-ho-so";
export const dichVuHoSoApi = {
  SelectAll: () => apiClient.get(`${DICH_VU_HO_SO_ENDPOINT}`),
  SelectVmByDichVu: (id_dich_vu: number) =>
    apiClient.get(`${DICH_VU_HO_SO_ENDPOINT}/selectvm-by-dichvu/${id_dich_vu}`),
  Insert: (payload: IDichVuHoSo) =>
    apiClient.post(`${DICH_VU_HO_SO_ENDPOINT}`, payload),
  Update: (payload: IDichVuHoSo) =>
    apiClient.put(`${DICH_VU_HO_SO_ENDPOINT}`, payload),
  Delete: (id: number) => apiClient.delete(`${DICH_VU_HO_SO_ENDPOINT}/${id}`),
  Deletes: (payload: number[]) =>
    apiClient.post(`${DICH_VU_HO_SO_ENDPOINT}/delete-many`, payload),
  Import: (payload: FormData) =>
    apiClient.upload(`${DICH_VU_HO_SO_ENDPOINT}/import`, payload),
  ExportFileTemp: () =>
    apiClient.post(`${DICH_VU_HO_SO_ENDPOINT}/export-file-temp`),
};
